<div class="container mt-4" (mousemove)="startInactivityTimer()" (keydown)="startInactivityTimer()">
  <!-- ✅ MODAL DE CONFIRMACIÓN PARA ELIMINAR -->
  <div
    *ngIf="mostrarConfirmacion"
    class="modal fade show d-block"
    style="background-color: rgba(0, 0, 0, 0.5)"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-warning">
          <h5 class="modal-title">⚠️ Confirmar Eliminación</h5>
        </div>
        <div class="modal-body">
          <p class="mb-0">{{ mensajeConfirmacion }}</p>
          <p class="text-muted small mt-2">Esta acción no se puede deshacer.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="cancelarEliminacion()">
            ❌ Cancelar
          </button>
          <button type="button" class="btn btn-danger" (click)="confirmarEliminacion()">
            ✅ Sí, Eliminar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Botones superiores -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div class="btn-group">
      <button class="btn btn-primary" (click)="setModo('crear')">➕ Crear</button>
      <button class="btn btn-info" (click)="setModo('buscar')">🔍 Buscar</button>
      <button class="btn btn-success" (click)="setModo('mostrar')">📦 Mostrar Productos</button>
    </div>
    <button class="btn btn-outline-danger" (click)="logout()">🚪 Cerrar sesión</button>
  </div>

  <!-- Mensaje cuando no hay modo seleccionado -->
  <div *ngIf="modo === null" class="text-center py-5">
    <div class="alert alert-info">
      <h4>👋 ¡Bienvenido!</h4>
      <p class="mb-0">Selecciona una opción del menú superior para comenzar</p>
    </div>
  </div>

  <!-- Mensajes de estado -->
  <div
    *ngIf="mensaje"
    [class]="mensaje.includes('✅') ? 'alert alert-success' : 'alert alert-danger'"
    class="alert-dismissible fade show"
  >
    {{ mensaje }}
    <button type="button" class="btn-close" (click)="mensaje = ''"></button>
  </div>

  <!-- Spinner de carga -->
  <div *ngIf="cargando" class="text-center my-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="mt-2 text-muted">Procesando...</p>
  </div>

  <!-- MODO CREAR -->
  <div *ngIf="modo === 'crear'">
    <div class="card shadow-sm">
      <div class="card-header bg-primary text-white">
        <h4 class="mb-0">➕ Crear Nuevo Producto</h4>
      </div>
      <div class="card-body">
        <form (ngSubmit)="guardarProducto()" #productoForm="ngForm">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Nombre del Producto *</label>
              <input
                [(ngModel)]="producto.name"
                name="nombre"
                class="form-control"
                placeholder="Ej: Mesa de centro"
                required
              />
            </div>

            <div class="col-md-6">
              <label class="form-label">Precio *</label>
              <input
                type="number"
                [(ngModel)]="producto.price"
                name="precio"
                class="form-control"
                placeholder="Ej: 299.99"
                min="0"
                step="0.01"
                required
              />
            </div>

            <div class="col-12">
              <label class="form-label">Descripción *</label>
              <input
                [(ngModel)]="producto.description"
                name="description"
                class="form-control"
                placeholder="Descripción del producto"
                required
              />
            </div>

            <div class="col-md-6">
              <label class="form-label">Categoría *</label>
              <input
                [(ngModel)]="producto.category"
                name="categoria"
                class="form-control"
                placeholder="Ej: Muebles, Decoración"
                required
              />
            </div>

            <div class="col-md-6">
              <label class="form-label">Stock *</label>
              <input
                type="number"
                [(ngModel)]="producto.stock"
                name="stock"
                class="form-control"
                placeholder="Cantidad disponible"
                min="0"
                required
              />
            </div>

            <div class="col-12">
              <button
                class="btn btn-success w-100 py-2"
                type="submit"
                [disabled]="cargando || !productoForm.form.valid"
              >
                {{ cargando ? '⏳ Guardando...' : '💾 Guardar Producto' }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- MODO BUSCAR -->
  <div *ngIf="modo === 'buscar'">
    <div class="card shadow-sm">
      <div class="card-header bg-info text-white">
        <h4 class="mb-0">🔍 Buscar Productos</h4>
      </div>
      <div class="card-body">
        <div class="input-group mb-3">
          <input
            [(ngModel)]="busqueda"
            name="busqueda"
            class="form-control form-control-lg"
            placeholder="Escribe al menos 3 letras para buscar..."
            (keyup.enter)="buscar()"
          />
          <button
            class="btn btn-info btn-lg"
            (click)="buscar()"
            [disabled]="cargando || busqueda.length < 3"
          >
            {{ cargando ? 'Buscando...' : '🔍 Buscar' }}
          </button>
        </div>

        <!-- Resultados de búsqueda - VISTA MEJORADA PARA MÓVILES -->
        <div *ngIf="productos.length > 0" class="mt-4">
          <h5 class="text-muted mb-3">📊 Resultados encontrados: {{ productos.length }}</h5>

          <!-- Vista de tabla para pantallas grandes -->
          <div class="d-none d-md-block">
            <div class="table-responsive">
              <table class="table table-striped table-hover">
                <thead class="table-dark">
                  <tr>
                    <th>Nombre</th>
                    <th>Precio</th>
                    <th>Descripción</th>
                    <th>Categoría</th>
                    <th>Stock</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let p of productos">
                    <td>
                      <input
                        [(ngModel)]="p.name"
                        class="form-control form-control-sm"
                        [readonly]="!p.modoEdicion"
                      />
                    </td>
                    <td>
                      <input
                        [(ngModel)]="p.price"
                        type="number"
                        class="form-control form-control-sm"
                        [readonly]="!p.modoEdicion"
                      />
                    </td>
                    <td>
                      <input
                        [(ngModel)]="p.description"
                        class="form-control form-control-sm"
                        [readonly]="!p.modoEdicion"
                      />
                    </td>
                    <td>
                      <input
                        [(ngModel)]="p.category"
                        class="form-control form-control-sm"
                        [readonly]="!p.modoEdicion"
                      />
                    </td>
                    <td>
                      <input
                        [(ngModel)]="p.stock"
                        type="number"
                        class="form-control form-control-sm"
                        [readonly]="!p.modoEdicion"
                      />
                    </td>
                    <td>
                      <div class="btn-group btn-group-sm">
                        <button
                          class="btn"
                          [ngClass]="p.modoEdicion ? 'btn-success' : 'btn-warning'"
                          (click)="p.modoEdicion ? guardarEdicion(p) : activarEdicion(p)"
                          [disabled]="cargando"
                        >
                          {{ p.modoEdicion ? '💾' : '✏️' }}
                        </button>
                        <!-- ✅ CAMBIADO: eliminar(p) por solicitarEliminacion(p) -->
                        <button
                          class="btn btn-danger"
                          (click)="solicitarEliminacion(p)"
                          [disabled]="cargando"
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Vista de tarjetas para pantallas pequeñas -->
          <div class="d-block d-md-none">
            <div class="row g-3">
              <div *ngFor="let p of productos" class="col-12">
                <div class="card h-100">
                  <div class="card-header d-flex justify-content-between align-items-center">
                    <strong>{{ p.name }}</strong>
                    <span class="badge bg-primary">${{ p.price }}</span>
                  </div>
                  <div class="card-body">
                    <div class="mb-2">
                      <strong>Descripción:</strong>
                      <div *ngIf="!p.modoEdicion" class="mt-1">{{ p.description }}</div>
                      <input
                        *ngIf="p.modoEdicion"
                        [(ngModel)]="p.description"
                        class="form-control form-control-sm mt-1"
                      />
                    </div>

                    <div class="mb-2">
                      <strong>Categoría:</strong>
                      <div *ngIf="!p.modoEdicion" class="mt-1">{{ p.category }}</div>
                      <input
                        *ngIf="p.modoEdicion"
                        [(ngModel)]="p.category"
                        class="form-control form-control-sm mt-1"
                      />
                    </div>

                    <div class="mb-2">
                      <strong>Stock:</strong>
                      <div *ngIf="!p.modoEdicion" class="mt-1">{{ p.stock }} unidades</div>
                      <input
                        *ngIf="p.modoEdicion"
                        type="number"
                        [(ngModel)]="p.stock"
                        class="form-control form-control-sm mt-1"
                      />
                    </div>

                    <!-- Campos editables para nombre y precio en móviles -->
                    <div *ngIf="p.modoEdicion" class="mb-2">
                      <strong>Nombre:</strong>
                      <input [(ngModel)]="p.name" class="form-control form-control-sm mt-1" />
                    </div>

                    <div *ngIf="p.modoEdicion" class="mb-2">
                      <strong>Precio:</strong>
                      <input
                        type="number"
                        [(ngModel)]="p.price"
                        class="form-control form-control-sm mt-1"
                      />
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="btn-group w-100">
                      <button
                        class="btn btn-sm flex-fill"
                        [ngClass]="p.modoEdicion ? 'btn-success' : 'btn-warning'"
                        (click)="p.modoEdicion ? guardarEdicion(p) : activarEdicion(p)"
                        [disabled]="cargando"
                      >
                        {{ p.modoEdicion ? '💾 Guardar' : '✏️ Editar' }}
                      </button>
                      <!-- ✅ CAMBIADO: eliminar(p) por solicitarEliminacion(p) -->
                      <button
                        class="btn btn-sm btn-danger flex-fill"
                        (click)="solicitarEliminacion(p)"
                        [disabled]="cargando"
                      >
                        🗑️ Eliminar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODO MOSTRAR -->
  <div *ngIf="modo === 'mostrar'">
    <div class="card shadow-sm">
      <div
        class="card-header bg-success text-white d-flex justify-content-between align-items-center"
      >
        <h4 class="mb-0">📦 Lista de Productos</h4>
        <button class="btn btn-outline-light btn-sm" (click)="cargarProductos()">
          🔄 Actualizar
        </button>
      </div>
      <div class="card-body">
        <div *ngIf="productos.length > 0; else noProductos">
          <!-- Vista de tabla para pantallas grandes -->
          <div class="d-none d-md-block">
            <div class="table-responsive">
              <table class="table table-striped table-hover">
                <thead class="table-dark">
                  <tr>
                    <th>Nombre</th>
                    <th>Precio</th>
                    <th>Descripción</th>
                    <th>Categoría</th>
                    <th>Stock</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let p of productos">
                    <td>
                      <input
                        [(ngModel)]="p.name"
                        class="form-control form-control-sm"
                        [readonly]="!p.modoEdicion"
                      />
                    </td>
                    <td>
                      <input
                        [(ngModel)]="p.price"
                        type="number"
                        class="form-control form-control-sm"
                        [readonly]="!p.modoEdicion"
                      />
                    </td>
                    <td>
                      <input
                        [(ngModel)]="p.description"
                        class="form-control form-control-sm"
                        [readonly]="!p.modoEdicion"
                      />
                    </td>
                    <td>
                      <input
                        [(ngModel)]="p.category"
                        class="form-control form-control-sm"
                        [readonly]="!p.modoEdicion"
                      />
                    </td>
                    <td>
                      <input
                        [(ngModel)]="p.stock"
                        type="number"
                        class="form-control form-control-sm"
                        [readonly]="!p.modoEdicion"
                      />
                    </td>
                    <td>
                      <div class="btn-group btn-group-sm">
                        <button
                          class="btn"
                          [ngClass]="p.modoEdicion ? 'btn-success' : 'btn-warning'"
                          (click)="p.modoEdicion ? guardarEdicion(p) : activarEdicion(p)"
                          [disabled]="cargando"
                        >
                          {{ p.modoEdicion ? '💾 Guardar' : '✏️ Editar' }}
                        </button>
                        <!-- ✅ CAMBIADO: eliminar(p) por solicitarEliminacion(p) -->
                        <button
                          class="btn btn-danger"
                          (click)="solicitarEliminacion(p)"
                          [disabled]="cargando"
                        >
                          🗑️ Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Vista de tarjetas para pantallas pequeñas -->
          <div class="d-block d-md-none">
            <div class="row g-3">
              <div *ngFor="let p of productos" class="col-12">
                <div class="card h-100">
                  <div class="card-header d-flex justify-content-between align-items-center">
                    <strong>{{ p.name }}</strong>
                    <span class="badge bg-primary">${{ p.price }}</span>
                  </div>
                  <div class="card-body">
                    <div class="mb-2">
                      <strong>Descripción:</strong>
                      <div *ngIf="!p.modoEdicion" class="mt-1">{{ p.description }}</div>
                      <input
                        *ngIf="p.modoEdicion"
                        [(ngModel)]="p.description"
                        class="form-control form-control-sm mt-1"
                      />
                    </div>

                    <div class="mb-2">
                      <strong>Categoría:</strong>
                      <div *ngIf="!p.modoEdicion" class="mt-1">{{ p.category }}</div>
                      <input
                        *ngIf="p.modoEdicion"
                        [(ngModel)]="p.category"
                        class="form-control form-control-sm mt-1"
                      />
                    </div>

                    <div class="mb-2">
                      <strong>Stock:</strong>
                      <div *ngIf="!p.modoEdicion" class="mt-1">{{ p.stock }} unidades</div>
                      <input
                        *ngIf="p.modoEdicion"
                        type="number"
                        [(ngModel)]="p.stock"
                        class="form-control form-control-sm mt-1"
                      />
                    </div>

                    <!-- Campos editables para nombre y precio en móviles -->
                    <div *ngIf="p.modoEdicion" class="mb-2">
                      <strong>Nombre:</strong>
                      <input [(ngModel)]="p.name" class="form-control form-control-sm mt-1" />
                    </div>

                    <div *ngIf="p.modoEdicion" class="mb-2">
                      <strong>Precio:</strong>
                      <input
                        type="number"
                        [(ngModel)]="p.price"
                        class="form-control form-control-sm mt-1"
                      />
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="btn-group w-100">
                      <button
                        class="btn btn-sm flex-fill"
                        [ngClass]="p.modoEdicion ? 'btn-success' : 'btn-warning'"
                        (click)="p.modoEdicion ? guardarEdicion(p) : activarEdicion(p)"
                        [disabled]="cargando"
                      >
                        {{ p.modoEdicion ? '💾 Guardar' : '✏️ Editar' }}
                      </button>
                      <!-- ✅ CAMBIADO: eliminar(p) por solicitarEliminacion(p) -->
                      <button
                        class="btn btn-sm btn-danger flex-fill"
                        (click)="solicitarEliminacion(p)"
                        [disabled]="cargando"
                      >
                        🗑️ Eliminar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noProductos>
          <div class="text-center py-5">
            <p class="text-muted fs-5">📭 No hay productos disponibles</p>
            <button class="btn btn-primary" (click)="cargarProductos()">
              🔄 Intentar de nuevo
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
